import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchSentimientoFilters = async (user, token) => {
  const params = new URLSearchParams({
    user,
    key: api_auth,
    token,
  });

  const url = `${api_host}/reporte/online/indicadores/getSentimientoFilters/?${params.toString()}`;
  
  const response = await fetch(url);
  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const useSentimientoFilters = (options = {}) => {
  const { user, token } = getApiKeys();

  return useQuery({
    queryKey: ['sentimientoFilters', user],
    queryFn: () => fetchSentimientoFilters(user, token),
    enabled: !!user && !!token,
    staleTime: 1000 * 60 * 5, //5m
    keepPreviousData: true,
    ...options
  });
};
